import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { Dispatch } from 'src/app/_core/tools/decorators/dispatch.decorator';
import { UserDelegation } from 'src/app/_user/components/user-delegation-picker/user-delegation-picker.component';
import {
    GetFunctionalitiesAndWidgetsAccessibleAction,
    LogoutAction,
    SaveUserLoginInformationsAction
} from 'src/app/_user/store/user/user.action';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Component({
    selector: 'app-multi-delegations',
    templateUrl: './multi-delegations.component.html',
    styleUrls: ['./multi-delegations.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MultiDelegationsComponent extends BaseComponent {

    delegationPickerFormControl = new FormControl<UserDelegation | null>(null);

    constructor(protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    saveDelegation(): void {
        if (this.delegationPickerFormControl.invalid) {
            return;
        }

        this.loading = true;
        this.watch$ = this.dispatch$(new SaveUserLoginInformationsAction(this.delegationPickerFormControl.value)).pipe(
            switchMap(() => this.dispatch$(new GetFunctionalitiesAndWidgetsAccessibleAction())),
            tap(() => this.loading = false),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            })
        );
    }

    @Dispatch(new LogoutAction())
    logout(): void {
    }
}
